import { useEffect } from 'react';

/**
 * Service worker is disabled. Any previously-installed SW is unregistered so
 * users stop seeing the "a new version is available" prompt and forced reloads
 * caused by stale caches.
 */
export function ServiceWorkerManager() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker
      .getRegistrations()
      .then(regs => regs.forEach(reg => void reg.unregister()))
      .catch(() => {
        /* ignore — nothing to clean up */
      });
  }, []);

  return null;
}
